import type { Verdict } from './types';

export type VerdictOrPending = Verdict | 'pending';

/** docs/design/components.md §2.3 の表 */
export const VERDICT_LABELS: Record<VerdictOrPending, string> = {
  AC: '正解',
  WA: '不正解',
  TLE: '時間切れ',
  RE: '実行時エラー',
  CE: 'コンパイルエラー',
  pending: '判定中',
};

/** 読み上げ用。「AC、正解」 */
export function verdictSpeech(v: VerdictOrPending): string {
  return v === 'pending' ? VERDICT_LABELS.pending : `${v}、${VERDICT_LABELS[v]}`;
}
